<template>
<v-container>

  <v-navigation-drawer
        v-model="drawer"
        permanent
        :mini-variant.sync="mini"
        app
        dark
    > 
    <v-list-item class="px-2">
      <v-list-item-avatar>
        <v-img src="../assets/logo-zoomed.png"></v-img>
      </v-list-item-avatar>

      <v-list-item-title>Socials</v-list-item-title>

      <v-btn icon @click.stop="mini = !mini">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </v-list-item>

    <v-divider></v-divider>
      <v-list nav dense>
        <v-list-item link href="https://www.facebook.com/rosenrecordlabel" target="_blank">
          <v-list-item-icon>
            <v-icon>mdi-facebook</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Facebook</v-list-item-title>
        </v-list-item>
        <v-list-item link href="https://www.instagram.com/donrosenbergzz/" target="_blank">
          <v-list-item-icon>
            <v-icon>mdi-instagram</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Instagram</v-list-item-title>
        </v-list-item>
        <v-list-item link href="https://open.spotify.com/artist/6WvsXK4GWpa0Uib3S6K4b6" target="_blank">
          <v-list-item-icon>
            <v-icon>mdi-spotify</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Spotify</v-list-item-title>
        </v-list-item>
        <v-list-item link href="https://music.apple.com/us/artist/chippo/1484555400" target="_blank">
          <v-list-item-icon>
            <v-icon>mdi-apple</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Apple Music</v-list-item-title>
        </v-list-item>
        <v-list-item link href="https://tidal.com/artist/8249831" target="_blank">
          <v-list-item-icon>
            <v-img maxwidth="16" aspect-ratio="1/1"  cover :src=tidal></v-img>
          </v-list-item-icon>
          <v-list-item-title>Tidal</v-list-item-title>
        </v-list-item>
        <v-list-item link href="https://www.youtube.com/channel/UCuShvzW2QxRIvEIjW3HgPMw" target="_blank">
          <v-list-item-icon>
            <v-icon>mdi-youtube</v-icon>
          </v-list-item-icon>
          <v-list-item-title>YouTube</v-list-item-title>
        </v-list-item>
        <v-list-item link href="https://soundcloud.com/poul-rosenberg" target="_blank">
          <v-list-item-icon>
            <v-icon>mdi-soundcloud</v-icon>
          </v-list-item-icon>
          <v-list-item-title>SoundCloud</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
</v-container>
</template>


<script>
import tidaldiamonds from '../assets/tidaldiamonds.png'
export default {
    name: 'Socials-bar',
    data() {
        return {
            drawer: true,
            mini: true,
            tidal: tidaldiamonds
        }
    },
    methods: {

    }

}
</script>
